import { render } from "./FormSelectMultiple.vue?vue&type=template&id=12f5acea"
import script from "./FormSelectMultiple.vue?vue&type=script&lang=js"
export * from "./FormSelectMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__